<template>
  <div class="regionalEquipment">
    <ul class="leftMenu">
      <li
        v-for="v in menuList"
        :key="v.name"
        :class="defaultSelect.name == v.name ? 'activetItem' : ''"
        @click="changeMenu(v.name)"
      >
        <p>{{ v.name }} {{ v.count }}</p>
      </li>
    </ul>
    <div
      :class="{ rightCont: true, ashComWrap: defaultSelect.name == '固定资产' }"
    >
      <div class="propertyTable" v-if="defaultSelect.name == '固定资产'">
        <OriginalTable :tableHead="tableHead" :tableList="tableList" />
      </div>

      <ECEquipment
        v-if="defaultSelect.name == '用能设备'"
        :typeMenuData="typeMenuData"
      />

      <div
        class="publicContentBox"
        v-if="
          defaultSelect.name == '量测设备' || defaultSelect.name == '传感器'
        "
      >
        <el-tabs v-model="activeTypeId" type="card" @tab-click="changeTabs">
          <el-tab-pane
            v-for="v in typeList"
            :key="v.typeId"
            :label="v.name + ' ' + v.count"
            :name="v.typeId"
          ></el-tab-pane>
        </el-tabs>
        <div
          class="contentBox"
          :style="{
            background: defaultSelect.name == '量测设备' ? '#fff' : '#f7f7f7',
          }"
        >
          <template v-if="defaultSelect.name == '传感器'">
            <li v-for="(v, i) in dataList" :key="i">
              <el-tooltip
                class="item"
                effect="dark"
                :content="v.name"
                placement="top-start"
                :disabled="v.name?.length < 10"
              >
                <p>{{ v.name }}</p>
              </el-tooltip>

              <p>状态: {{ v.online ? "在线" : "离线" }}</p>
              <p v-for="(item, index) in v.attribute" :key="index">
                {{ item.name }}: {{ item.value }}{{ item.unit }}
              </p>
            </li>
          </template>
          <div class="propertyTable" v-if="defaultSelect.name == '量测设备'">
            <div class="tableContent">
              <OriginalTable :tableHead="tableHead" :tableList="tableList" />
            </div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 30, 50, 100]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              style="margin-top: 10px; text-align: right"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OriginalTable from "@/components/table/OriginalTable.vue";
import ECEquipment from "./ECEquipment.vue";
import { ANGLEDEFAULT, WEATHERDEFAULT } from "@/assets/js/const";
import api from "@/api";
import { handleNumDecimal } from "@/assets/js/utils";
export default {
  props: {
    treeActive: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    OriginalTable,
    ECEquipment,
  },
  data() {
    return {
      defaultSelect: {},
      menuList: [],
      typeList: [],
      activeTypeId: "",
      tableHead: [],
      tableList: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      dataList: [],
      typeMenuData: {},
      treeId: "",
      countNum: 0,
    };
  },
  watch: {
    treeActive: {
      handler() {
        if (this.treeActive.id) {
          this.treeId = this.treeActive.id;
          this.getMenuList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getMenuList() {
      this.menuList = [];
      this.defaultSelect = {};
      let res = await api.BMSGetRgionDeviceCount({
        assetId: this.treeId,
      });

      if (res && res.data.code == 200) {
        this.menuList = res.data.data;
        this.defaultSelect = this.menuList[0] ?? {};
        this.changeMenu(this.defaultSelect.name);
      }
    },
    // 获取传感器详情
    async getRgionSecsorDetail() {
      this.dataList = [];
      let res = await api.BMSGetRgionSecsorDetail({
        assetId: this.treeId,
        typeId: this.activeTypeId,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.dataList = res.data.data?.length ? res.data.data : [];
        this.dataList.map((v) => {
          v.attribute.map((item) => {
            if (item.key === "Weather") {
              item.value = WEATHERDEFAULT?.[item.value] || "-";
            } else if (item.key === "WindDirection") {
              item.value = ANGLEDEFAULT?.[item.value] || "-";
            } else if (item.key === "RunSign") {
              item.value = v.value == 1 ? "在线" : "离线";
            } else {
              item.value = handleNumDecimal(item.value);
            }
          });
        });
      }
    },
    // 获取量测设备详情
    async getRgionMeasurementDetail() {
      this.tableList = [];
      let res = await api.BMSGetRgionMeasurementDetail({
        assetId: this.treeId,
        typeId: this.activeTypeId,
        pageSize: this.page.size,
        page: this.currentPage - 1,
      });
      if (res && res.status == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableList = Array.from(res.data.data).map((v) => ({
          deviceName: v.deviceName,
          realtimeValue: handleNumDecimal(v.realtimeValue),
          dayValue: handleNumDecimal(v.dayValue),
          monthValue: handleNumDecimal(v.monthValue),
          yearValue: handleNumDecimal(v.yearValue),
        }));
        this.page.total = res.data.totalElements;
      }
    },

    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getRgionMeasurementDetail();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRgionMeasurementDetail();
    },
    changeMenu(name) {
      this.typeList = [];
      this.defaultSelect = this.menuList.find((v) => {
        return v.name === name;
      });

      this.typeList = this.defaultSelect.typeList ?? [];
      this.activeTypeId = this.typeList[0]?.typeId ?? "";
      this.changeTabs();
    },
    changeTabs() {
      if (this.defaultSelect.name === "用能设备") {
        this.countNum += 1;
        this.typeMenuData = {
          countNum: this.countNum,
          treeActive: this.treeActive,
          typeList: this.typeList,
        };
        return;
      }
      this.$store.commit("SET_LOADING", true);
      if (this.defaultSelect.name === "传感器") {
        this.getRgionSecsorDetail();
      } else if (this.defaultSelect.name === "量测设备") {
        let obj = this.typeList.find((v) => {
          return v.typeId === this.activeTypeId;
        });
        let unit = obj.name === "电表" ? "kw·h" : "m³",
          title =
            obj.name === "电表"
              ? "用电"
              : obj.name === "水表"
              ? "用水"
              : "用气";

        this.tableHead = [
          { label: `${obj.name}名称`, prop: "deviceName" },
          { label: `实时${title}/${unit}`, prop: "realtimeValue" },
          { label: `今日${title}/${unit}`, prop: "dayValue" },
          { label: `本月${title}/${unit}`, prop: "monthValue" },
          { label: `今年${title}/${unit}`, prop: "yearValue" },
        ];
        this.handleSizeChange(10);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.regionalEquipment {
  width: 100%;
  height: 100%;
  @include setFlexBetween;
  align-items: flex-start;
  .leftMenu {
    width: 18%;
    background: #fff;
    border-radius: 6px;
    li {
      width: 90%;
      text-indent: 30px;
      line-height: 30px;
      margin: 10px auto;
    }
    li:hover {
      background: rgba(40, 204, 203, 0.5);
      color: #fff;
    }
    .activetItem {
      background: #28cccb;
      color: #fff;
    }
  }
  .rightCont {
    width: calc(82% - 12px);
    height: 100%;
    // background: sandybrown;
    .propertyTable {
      width: 96%;
      height: 96%;
      margin: 1% auto 0;
      .tableContent {
        width: 100%;
        height: 93%;
      }
    }
    .publicContentBox {
      width: 100%;
      height: 100%;
      ::v-deep .el-tabs--card > .el-tabs__header {
        margin: 0;
        border: none;
        .el-tabs__nav {
          border: none;
          .el-tabs__item {
            border: none;
            background: #fff;
            border-radius: 6px;
            margin-right: 13px;
          }
        }
        .el-tabs__item.is-active {
          background: #28cccb;
          color: #fff;
        }
      }
      .contentBox {
        width: 100%;
        height: calc(100% - 55px);
        margin-top: 12px;
        overflow: auto;
        li {
          display: inline-block;
          width: 150px;
          margin: 0 15px 10px 0;
          padding: 20px 20px 10px 20px;
          background: #fff;
          border-radius: 6px;
          p:nth-child(1) {
            text-align: center;
            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          p {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
